import type {
  ProofOfConclusionAPI,
  ProofsOfConclusionAPI,
} from './definitions/ApiTypes';
import type {
  ProofOfConclusion,
  ProofsOfConclusion,
} from './definitions/Types';

export const proofOfConclusionTransformer = (
  proofOfConclusionAPI: ProofOfConclusionAPI
): ProofOfConclusion => ({
  id: proofOfConclusionAPI.id,
  userId: proofOfConclusionAPI.user_id,
  userName: proofOfConclusionAPI.user_name,
  fleetId: proofOfConclusionAPI.fleet_id,
  client: proofOfConclusionAPI.client,
  address: proofOfConclusionAPI.address,
  observation: proofOfConclusionAPI.observation,
  imgUrls: proofOfConclusionAPI.img_urls,
  activityId: proofOfConclusionAPI.activity_id,
  vehicleId: proofOfConclusionAPI.vehicle_id,
  model: proofOfConclusionAPI.model,
  licensePlate: proofOfConclusionAPI.license_plate,
  savedAt: proofOfConclusionAPI.saved_at,
  completedAt: proofOfConclusionAPI.completed_at,
});

export const proofsOfConclusionTransformer = ({
  proofs_of_conclusion,
  has_data,
}: ProofsOfConclusionAPI): ProofsOfConclusion => ({
  proofsOfConclusion: proofs_of_conclusion.map(proofOfConclusionTransformer),
  hasData: has_data,
});
